const roundTo = (roundTo: number) => (date: number) =>
  Math.round(date / roundTo) * roundTo;
const roundDownTo = (roundTo: number) => (date: number) =>
  Math.floor(date / roundTo) * roundTo;
const roundUpTo = (roundTo: number) => (date: number) =>
  Math.ceil(date / roundTo) * roundTo;

export const roundTo5Minutes = roundTo(1000 * 60 * 5);
export const roundDownTo5Minutes = roundDownTo(1000 * 60 * 5);
export const roundDownTo10Minutes = roundDownTo(1000 * 60 * 10);
export const roundUpTo5Minutes = roundUpTo(1000 * 60 * 5);

export const roundDownToXMinutes = (date: number, minutes: number) => {
  return Math.floor(date / (minutes * 1000 * 60)) * (minutes * 1000 * 60);
};
